import * as actions from "./actions";
import initialState from "./initialState";
import reducer from "./reducer";

export const gameModeActions = actions;
export const gameModeInitialState = initialState;
export const gameModeReducer = reducer;
